import { SLICER_KEYS } from 'types/services';
import { createSlice } from '@reduxjs/toolkit';
import type { ChatbotSize, ChatHistory } from 'types/chatbot';

import { toggleOpen } from './reducers/toggleOpen';
import { toggleFullScreen } from './reducers/toggleFullScreen';
import { setSize } from './reducers/setSize';
import { saveConversation } from './reducers/saveConversation';
import { setHistory } from './reducers/setHistory';
import { setActiveHistoryId } from './reducers/setActiveHistoryId';

export interface ChatbotState {
  open: boolean;
  fullScreen: boolean;
  history: ChatHistory[];
  activeHistoryId: string | null;
  size: ChatbotSize;
}

const initialState: ChatbotState = {
  open: false,
  fullScreen: false,
  size: { w: 600, h: 700 },
  history: [],
  activeHistoryId: null,
};

export const chatbotState = createSlice({
  name: SLICER_KEYS.CHATBOT,
  initialState,
  reducers: {
    toggleOpen,
    toggleFullScreen,
    setSize,
    setHistory,
    saveConversation,
    setActiveHistoryId,
  },
});

export const chatbotStateActions = chatbotState.actions;
